import { render, staticRenderFns } from "./WForm.vue?vue&type=template&id=3abef2eb&scoped=true&"
import script from "./wForm.ts?vue&type=script&lang=ts&"
export * from "./wForm.ts?vue&type=script&lang=ts&"
import style0 from "./WForm.vue?vue&type=style&index=0&id=3abef2eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abef2eb",
  null
  
)

export default component.exports